// extracted by mini-css-extract-plugin
export default {"container":"Articles_container__sGZJ9","left":"Articles_left__SX5Uw","button":"Articles_button__3bKiS","desc":"Articles_desc__v5MOG","inter":"Articles_inter__cLOnG"};